import type { ApprovalStatus } from '../../shared/api/types';

export const APPROVAL_STATUS: Record<ApprovalStatus, string> = {
  pending: 'Por aprobar',
  approved: 'Aprobada',
  rejected: 'No aprobada',
  withdrawn: 'Retirada',
};

export const APPROVAL_BADGE: Record<ApprovalStatus, string> = {
  pending: 'badge badge--pending',
  approved: 'badge badge--active',
  rejected: 'badge badge--warn',
  withdrawn: 'badge',
};
